import React from 'react';
import SkillCategory from '../SkillCategory/SkillCategory';
import './TechnicalSkills.scss';

const TechnicalSkills = () => {
	const skillCategories = [
		{
			title: 'Frontend Development',
			skills: ['CSS/SCSS/LESS', 'GraphQL', 'JavaScript', 'Next.js', 'React.js', 'TypeScript'],
		},
		{
			title: 'Backend Development',
			skills: ['Node.js', 'PHP', 'Python', 'Ruby'],
		},
		{
			title: 'Accessibility',
			skills: ['Axe Core', 'IBM EAA', 'JAWS', 'NVDA', 'Pa11y', 'ReadSpeaker', 'WCAG 2.2'],
		},
		{
			title: 'DevOps & Cloud',
			skills: ['AWS Lambdas', 'AWS S3', 'CI/CD', 'Docker', 'GIT', 'Jenkins', 'Kubernetes'],
		},
		{
			title: 'Testing',
			skills: ['Cypress', 'Jest'],
		},
		{
			title: 'Design Tools',
			skills: ['Adobe Creative Suite', 'Balsamiq', 'Figma'],
		},
	];

	return (
		<div className="technical-skills">
			<h2 className="technical-skills__title">Technical Skills</h2>
			<div className="technical-skills__grid">
				{skillCategories.map((category, index) => (
					<SkillCategory key={index} title={category.title} skills={category.skills} />
				))}
			</div>
		</div>
	);
};

export default TechnicalSkills;
